// src/sot/primitives/Determinate.jsx
import React from "react";

/**
 * AfriMed Circular Determinate
 * - progress: 0..100 (numbers outside will be clamped)
 * - size: px (default 48)
 * - showLabel: toggle % label
 */
export default function Determinate({ progress = 0, size = 48, showLabel = false }) {
  const clamped = Math.min(100, Math.max(0, Number(progress) || 0));
  const r = 22;                      // circle radius for 48 viewBox
  const C = 2 * Math.PI * r;         // circumference

  return (
    <div className="inline-flex items-center gap-4">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={`Loading ${clamped}%`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(clamped)}
      >
        {/* Track */}
        <circle
          cx="24"
          cy="24"
          r={r}
          stroke="rgb(var(--afrimed-primary))"
          strokeOpacity="0.16"
          strokeWidth="4"
          fill="none"
        />

        {/* Progress arc */}
        <circle
          cx="24"
          cy="24"
          r={r}
          stroke="rgb(var(--afrimed-primary))"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
          strokeDasharray={C}
          strokeDashoffset={C * (1 - clamped / 100)}
          transform="rotate(-90 24 24)"
          style={{
            transition: "stroke-dashoffset 320ms cubic-bezier(.2,.65,.3,1)",
            vectorEffect: "non-scaling-stroke",
          }}
        />
      </svg>

      {showLabel && (
        <span className="text-body-medium text-on-surface-var">{clamped}%</span>
      )}
    </div>
  );
}